import { useRedirectFunctions } from '@propelauth/react';
import type React from 'react';
import AuthShell from './AuthShell';
import { postLoginRedirectUrl } from './loginRedirect';

interface LoginGateProps {
  text?: string;
  onSwitchToSignUp?: () => void;
}

const SIGN_IN_BUTTON_STYLE: React.CSSProperties = {
  width: '100%',
  padding: '13px 20px',
  background: '#2563EB',
  color: '#fff',
  border: 'none',
  borderRadius: 12,
  fontSize: 14,
  fontWeight: 700,
  cursor: 'pointer',
};

const SWITCH_LINK_STYLE: React.CSSProperties = {
  background: 'none',
  border: 'none',
  color: '#64748B',
  fontSize: 13,
  cursor: 'pointer',
};

export default function LoginGate({
  text = 'Sign in to access your Sydon STAC dashboard.',
  onSwitchToSignUp,
}: LoginGateProps): JSX.Element {
  const { redirectToLoginPage } = useRedirectFunctions();

  return (
    <AuthShell
      headline="Welcome back"
      subtext={text}
      footer={
        onSwitchToSignUp && (
          <button type="button" onClick={onSwitchToSignUp} style={SWITCH_LINK_STYLE}>
            Don't have an account?{' '}
            <span style={{ color: '#2563EB', fontWeight: 700 }}>Sign up free</span>
          </button>
        )
      }
    >
      <div style={{ textAlign: 'center', marginBottom: 22 }}>
        <div style={{ fontSize: 17, fontWeight: 700, color: '#0F172A' }}>Sign in</div>
        <div style={{ fontSize: 13, color: '#64748B', marginTop: 4 }}>
          Continue to your dashboard
        </div>
      </div>
      <button
        type="button"
        onClick={() => redirectToLoginPage({ postLoginRedirectUrl: postLoginRedirectUrl() })}
        style={SIGN_IN_BUTTON_STYLE}
      >
        Sign in
      </button>
    </AuthShell>
  );
}
